import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modal.actions';
import { getTroubleTicketReportedCode, deleteTroubleTicketReportedCode } from "../../../actions/troubleTicketCodes.action"
import { getModalData, getTroubleTicketCodes } from "../../../selectors";
import Loader from "../../../components/Loader";
import { toastr } from "react-redux-toastr";

class DeleteTroubleTicketReportedCodeModal extends Component {
    state = {
        isTroubleTicketReportedCodeLoading: true
    };

    componentDidMount() {
        const { modalProps } = this.props;
        if (modalProps.value) {
            this.props.getTroubleTicketReportedCode(modalProps.value).then((response) => {
                this.setState({
                    isTroubleTicketReportedCodeLoading: false
                })
            })
        } else {
            this.setState({
                isTroubleTicketReportedCodeLoading: false
            })
        }
    }

    closeModal = () => {
        this.props.hideModal();
    };

    deleteTroubleTicketReportedCode = () => {
        const { modalProps } = this.props;
        this.props.deleteTroubleTicketReportedCode(modalProps.value).then((response) => {
            this.props.hideModal();
            modalProps.reloadFunction(true);
            if (response && response.success) {
                toastr.success(response.message, { timeOut: 4000, position: 'top-center' });
            } else {
                toastr.error(response.error.message, { timeOut: 4000, position: 'top-center' });
            }
        })
    };

    render() {
        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    {this.state.isTroubleTicketReportedCodeLoading &&
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button onClick={this.props.hideModal} type="button" className="close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <Loader />
                                <div className="modal-footer">
                                </div>
                            </div>
                        </div>
                    }
                    {!this.state.isTroubleTicketReportedCodeLoading &&
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">CONFIRM DELETING TROUBLE TICKET REPORTED CODE</h5>
                                    <button type="button" className="close" onClick={this.closeModal}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="lead">You are about to delete the trouble ticket reported code</p>
                                    <div style={{
                                        backgroundColor: '#e9ecef',
                                        padding: '10px', borderRadius: '5px'
                                    }}>
                                        <span><i
                                            className={this.props.reportedCode.serviceModelIcon ?
                                                this.props.reportedCode.serviceModelIcon : ''} />&nbsp;{this.props.reportedCode.reportedCode}</span>
                                        <br />
                                        <span style={{ fontSize: ".75rem" }}>{this.props.reportedCode.description}</span>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button onClick={this.closeModal} className="btn">
                                        CANCEL
                                    </button>
                                    <button onClick={this.deleteTroubleTicketReportedCode} className="btn btn-danger">
                                        DELETE
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps,
        reportedCode = getTroubleTicketCodes(state).reportedCode;

    return {
        modalProps,
        reportedCode
    };
};

const mapDispatchToProps = {
    hideModal,
    getTroubleTicketReportedCode,
    deleteTroubleTicketReportedCode
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteTroubleTicketReportedCodeModal);
